import { useRelayEnvironment } from 'react-relay/hooks';
function useRelayEnvironments() {
    var environment = useRelayEnvironment();
    return {
        environments: [environment],
        defaultEnvironment: environment,
    };
}
export default useRelayEnvironments;
//# sourceMappingURL=useAllRelayEnvironments.js.map